import Alpine from "alpinejs";

class YoutubePlayerAPI {
    static jsIsLoading = false;
    static jsIsLoaded = false;

    static loadYoutubeApiScriptOnce() {
        if (YoutubePlayerAPI.jsIsLoading) return;
        YoutubePlayerAPI.jsIsLoading = true;

        // load scripts delayed to not block critical path
        window.addEventListener('load', () => {
            CookieConsentManager.onHasConsent('youtube', () => {
                setTimeout(() => {
                    let tag = document.createElement('script');
                    let firstScriptTag = document.getElementsByTagName('script')[0];

                    tag.src = 'https://www.youtube.com/iframe_api';
                    if (firstScriptTag) {
                        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
                    } else {
                        document.head.append(tag);
                    }
                    window.onYouTubeIframeAPIReady = () => YoutubePlayerAPI.jsIsLoaded = true
                }, 300);
            });
        });
    }
}

Alpine.data('youtubePlayer', (config) => ({
    config: config,
    overlayVisible: true,
    showFallbackPoster: !config.hasPoster && CookieConsentManager.hasConsent('youtube'),
    posterAlternativeText: config.posterAlternativeText,
    hasConsent: CookieConsentManager.hasConsent('youtube'),
    player: null,

    init() {
        YoutubePlayerAPI.loadYoutubeApiScriptOnce();

        CookieConsentManager.onHasConsent('youtube', () => {
            this.hasConsent = true;
            this.showFallbackPoster = !this.config.hasPoster;
            if (!config.posterAlternativeText) {
                fetch('https://www.youtube.com/oembed?url=http://www.youtube.com/watch?v=' + this.config.id + '&format=json')
                    .then(response => response.json())
                    .then(data => {
                        this.$effect(() => {
                            this.posterAlternativeText = data.title;
                        });
                    })
                    .catch(error => null);
            }
        });
    },

    startPlayingOnReady() {
        CookieConsentManager.onHasConsent('youtube', () => {
            this.startPlayerOnReady();
        });
    },

    startPlayerOnReady() {
        if (!YoutubePlayerAPI.jsIsLoaded) {
            setTimeout(() => this.startPlayerOnReady(), 100);
            return;
        }

        if (this.player) {
            this.player.playVideo();
            this.setState('playing');
        } else {
            this.setState('initialised');
            this.player = this.createPlayer();
        }
        this.$refs.iframe.focus();
    },

    createPlayer() {
        let options = {
            videoId: this.config.id,
            hl: this.config.language,
            iv_load_policy: 3,
            modestbranding: 1,
            enablejsapi: 1,
            playsinline: 1,
            autohide: 1,
            controls: 0,
            playlist: this.config.id,
            playerVars: {rel: 0, showinfo: 0, ecver: 2}
        }

        return new YT.Player(this.$refs.iframe, {
            events: {
                'onReady': () => {
                    if (this.config.seekTo) this.player.seekTo(this.config.seekTo);
                    this.player.playVideo();
                    this.setState('playing');
                },
                'onStateChange': (event) => {
                    const stateMap = {
                        '-1': 'unstarted',
                        '0': 'ended',
                        '1': 'playing',
                        '2': 'paused',
                        '3': 'buffering',
                        '5': 'cued'
                    };
                    this.setState(stateMap[event.data]);
                }
            },
            ...options
        });
    },

    setState(state) {
        const overlayVisibleMap = {
            initialised: false,
            unstarted: true,
            ended: true,
            playing: false,
            paused: false,
            buffering: false,
            cued: true,
        }
        this.overlayVisible = overlayVisibleMap[state];
    },
}));
